<template>
  <div class="bmi">
    <div
      v-if="isOnboardingRedesign"
      class="tw-mb-6"
    >
      <div class="tw-flex tw-gap-2 tw-items-center">
        <img
          :src="require('@/assets/images/onboarding/doctor-image.png')"
          alt=""
          class="tw-h-[70px] tw-mr-2"
        >
        <h2
          class="tw-mb-0 tw-flex-1 question-title tw-font-atten"
        >
          Please provide your height and weight.
        </h2>
      </div>
    </div>
    <h2
      v-else
      class="question-title"
    >
      What is your height and weight?
    </h2>
    <b-row>
      <b-col>
        <label
          for="height"
          class="label-text"
        >How tall are you?</label>
      </b-col>
    </b-row>
    <b-row>
      <b-col
        cols="12"
        :md="isOnboardingRedesign ? 12 : 6"
        class="mb-3"
      >
        <template v-if="isOnboardingRedesign">
          <b-form-input
            v-model="height.feet"
            type="tel"
            class="input-bg flat fs-mask bmi-input bmi-input-v2 tw-block tw-text-lg lg:tw-hidden"
            label="height"
            placeholder="Feet"
            :state="feetState"
            :formatter="numberOnly"
            readonly
            @click="showHeightModal = true"
          />
          <b-form-input
            v-model="height.feet"
            type="tel"
            class="input-bg flat fs-mask bmi-input bmi-input-v2 tw-hidden tw-text-lg lg:tw-block"
            label="height"
            placeholder="Feet"
            :state="feetState"
            :formatter="numberOnly"
          />
          <div
            v-if="!isValidFeet"
            class="tw-flex tw-items-center tw-gap-1 tw-mt-1"
          >
            <ErrorLabel class="tw-mt-5">
              Feet should not be greater than 8 or less than 3
            </ErrorLabel>
          </div>
        </template>
        <template v-else>
          <b-form-input
            v-model="height.feet"
            type="tel"
            class="input-bg flat fs-mask bmi-input"
            label="height"
            placeholder="Feet"
            :state="feetState"
            :formatter="numberOnly"
          />
        </template>
        <b-form-invalid-feedback id="bmi-feet">
          Input must be numbers only.
        </b-form-invalid-feedback>
      </b-col>
      <b-col
        cols="12"
        :md="isOnboardingRedesign ? 12 : 6"
      >
        <template v-if="isOnboardingRedesign">
          <b-form-input
            id="bmi-inch"
            v-model="height.inch"
            type="tel"
            class="input-bg flat fs-mask bmi-input bmi-input-v2 tw-block tw-text-lg lg:tw-hidden"
            label="height"
            placeholder="Inches"
            :state="inchState"
            :formatter="numberOnly"
            readonly
            @click="showHeightModal = true"
          />
          <b-form-input
            id="bmi-inch"
            v-model="height.inch"
            type="tel"
            class="input-bg flat fs-mask bmi-input bmi-input-v2 tw-hidden tw-text-lg lg:tw-block"
            label="height"
            placeholder="Inches"
            :state="inchState"
            :formatter="numberOnly"
          />
          <div
            v-if="!isValidInch"
            class="tw-flex tw-items-center tw-gap-1 tw-mt-1"
          >
            <ErrorLabel class="tw-mt-5">
              Inches should not be greater than 11
            </ErrorLabel>
          </div>
        </template>
        <template v-else>
          <b-form-input
            id="bmi-inch"
            v-model="height.inch"
            type="tel"
            class="input-bg flat fs-mask bmi-input"
            label="height"
            placeholder="Inches"
            :state="inchState"
            :formatter="numberOnly"
          />
        </template>
        <b-form-invalid-feedback id="bmi-inch">
          Input must be numbers only.
        </b-form-invalid-feedback>
      </b-col>
    </b-row>
    <b-row class="mt-4">
      <b-col
        cols="12"
        :md="isOnboardingRedesign ? 12 : 6"
      >
        <label
          for="weight"
          class="label-text"
        >How much do you weigh?</label>
        <template v-if="isOnboardingRedesign">
          <b-form-input
            id="bmi-weight"
            v-model="weight"
            class="input-bg flat fs-mask bmi-input bmi-input-v2 tw-block lg:tw-hidden"
            type="tel"
            label="weight"
            placeholder="Pounds"
            :state="weightState"
            :formatter="weightFormatter"
            readonly
            @click="showWeightModal = true"
          />
          <b-form-input
            id="bmi-weight"
            v-model="weight"
            class="input-bg flat fs-mask bmi-input bmi-input-v2 tw-hidden lg:tw-block"
            type="tel"
            label="weight"
            placeholder="Pounds"
            :state="weightState"
            :formatter="weightFormatter"
          />
          <div
            v-if="!isValidWeight"
            class="tw-flex tw-items-center tw-gap-1 tw-mt-1"
          >
            <ErrorLabel class="tw-mt-5">
              Weight should not be greater than 1000 or less than 50
            </ErrorLabel>
          </div>
        </template>
        <template v-else>
          <b-form-input
            id="bmi-weight"
            v-model="weight"
            class="input-bg flat fs-mask bmi-input"
            type="tel"
            label="weight"
            placeholder="Pounds"
            :state="weightState"
            :formatter="weightFormatter"
          />
        </template>
        <b-form-invalid-feedback id="bmi-weight">
          Input must be numbers only.
        </b-form-invalid-feedback>
      </b-col>
    </b-row>

    <CoreBottomSlideOutPanel
      :model-value="showHeightModal"
      :should-swipe-down="true"
      @update:modelValue="$event => (showHeightModal = $event)"
    >
      <template #header>
        <div class="tw-w-full">
          <div class="tw-w-full tw-flex tw-justify-between tw-px-5 tw-mb-2">
            <span
              class="close-bottom-modal tw-text-lg tw-text-[#828282] tw-cursor-pointer"
              @click="showHeightModal = false"
            >
              Cancel
            </span>
            <div class="tw-w-[33.33%] tw-flex tw-justify-between">
              <span
                class="tw-w-[50px] md:tw-w-[200px] tw-text-center tw-text-md tw-mb-0 tw-text-lg tw-font-bold"
              >
                Feet
              </span>
              <span
                class="tw-w-[50px] md:tw-w-[200px] tw-text-center tw-text-md tw-mb-0 tw-text-lg tw-font-bold"
              >
                Inches
              </span>
            </div>
            <span
              class="tw-text-[#AF8EFF] tw-text-lg tw-cursor-pointer"
              @click="handleHeightChange"
            >
              Confirm
            </span>
          </div>
          <div class="tw-w-full tw-h-[1px] tw-border-b md:!tw-top-[80px] tw-mb-2 tw-border-[#C7C7C7]"></div>
        </div>
      </template>
      <div
        class="min-[320px]:text-center md:tw-scale-[1.1] tw-origin-top tw-my-auto"
      >
        <Height
          :value="heightValue"
          @input="(height) => selectedHeight = height"
        />
      </div>
    </CoreBottomSlideOutPanel>

    <CoreBottomSlideOutPanel
      :model-value="showWeightModal"
      :should-swipe-down="true"
      @update:modelValue="$event => (showWeightModal = $event)"
    >
      <template #header>
        <div class="tw-w-full">
          <div class="tw-w-full tw-flex tw-justify-between tw-px-5 tw-mb-2">
            <span
              class="close-bottom-modal tw-text-lg tw-text-[#828282]"
              @click="showWeightModal = false"
            >
              Cancel
            </span>
            <span
              class="tw-text-md tw-mb-0 tw-text-lg tw-font-bold"
            >
              Weight
            </span>
            <span
              class="tw-text-[#AF8EFF] tw-text-lg tw-cursor-pointer"
              @click="handleWeightChange"
            >
              Confirm
            </span>
          </div>
          <div class="tw-w-full tw-h-[1px] tw-border-b md:!tw-top-[80px] tw-mb-2 tw-border-[#C7C7C7]"></div>
        </div>
      </template>
      <div
        class="min-[320px]:text-center md:tw-scale-[1.1] tw-origin-top  tw-my-auto"
      >
        <Weight
          :value="weight"
          @input="(weight) => selectedWeight = weight"
        />
      </div>
    </CoreBottomSlideOutPanel>

    <OnboardingCTAContainer>
      <b-button
        pill
        block
        variant="info"
        :disabled="isOnboardingRedesign ? (disabled || (hasEmptyValues || !(isValidFeet && isValidInch && isValidWeight))) : disabled"
        class="slight-rounded"
        :class="{'tw-max-w-[300px] tw-mx-auto tw-text-base md:tw-text-lg': isOnboardingRedesign}"
        @click="submitAnswer"
      >
        Continue
      </b-button>
    </OnboardingCTAContainer>
  </div>
</template>

<script>
import { mapState } from 'vuex'
// components
import OnboardingCTAContainer from '@/components/onboarding/OnboardingCTAContainer';
import analyticsMixin from '@/mixins/analytics';
import Height from '@/components/onboarding/bmi/Height.vue';
import Weight from '@/components/onboarding/bmi/Weight.vue';
import CoreBottomSlideOutPanel from '@corefront/components-v2/CoreBottomSlideOutPanel/CoreBottomSlideOutPanel.vue';
import ErrorLabel from '@/components/partials/ErrorLabel.vue';

export default {
  components: {
    ErrorLabel,
    Height,
    Weight,
    CoreBottomSlideOutPanel,
    OnboardingCTAContainer,
  },
  mixins: [analyticsMixin],
  props: {
    bmi: {
      type: Object,
      default() {
        return {
          height: {
            feet: '',
            inch: '',
          },
          weight: '',
        };
      },
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    userid: {
      type: String,
      default: '',
    },
    onboardingflow: {
      type: String,
      default: 'flowA',
    },
    firstname: {
      type: String,
      default: '',
    },
    lastname: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      height: {
        feet: '',
        inch: '',
      },
      selectedHeight: '',
      weight: '',
      selectedWeight: '',
      showHeightModal: false,
      showWeightModal: false
    };
  },
  computed: {
    ...mapState('global', ['isOnboardingRedesign']),
    hasEmptyValues() {
      return this.height.feet === '' || this.height.inch === '' || this.weight === '';
    },
    feetState() {
      return !!this.height.feet || this.height.feet.length == 0;
    },
    inchState() {
      return (
        !!this.height.inch ||
        this.height.inch.length == 0 ||
        this.height.inch == 0
      );
    },
    weightState() {
      return !!this.weight || this.weight.length == 0;
    },
    isValidFeet() {
      return this.height.feet === '' || (this.height.feet >= 3 && this.height.feet <= 8);
    },
    isValidInch() {
      return (this.height.inch === '' || this.height.inch === 0) || (this.height.inch >= 0 && this.height.inch <= 11);
    },
    isValidWeight() {
      return this.weight === '' || (this.weight >= 50 && this.weight <= 1000);
    },
    heightValue() {
      return `${this.height.feet}'${this.height.inch}`
    }
  },
  async mounted() {
    if (this.bmi.height.feet) {
      this.height.feet = this.bmi.height.feet;
    }
    if (this.bmi.height.inch || this.bmi.height.inch == 0) {
      this.height.inch = this.bmi.height.inch;
    }
    if (this.bmi.weight) {
      this.weight = this.bmi.weight;
    }

    await this.$_analytics_track(
      'Onboarding Screen Viewed',
      {
        customerId: this.userid,
        screen: '2.99-A',
        onboardingflow: this.onboardingflow,
        firstname: this.firstname,
        lastname: this.lastname,
      },
    );
  },
  methods: {
    handleHeightChange() {
      if (this.selectedHeight) {
        this.height.feet = this.selectedHeight.split("'")[0];
        this.height.inch = this.selectedHeight.split("'")[1].replace('"', '');
      }
      this.showHeightModal = false;
    },
    handleWeightChange() {
      if (this.selectedWeight) {
        this.weight = this.selectedWeight;
      }
      this.showWeightModal = false;
    },
    submitAnswer() {
      if (!this.isOnboardingRedesign) {
        if (
          !this.height.feet ||
          this.height.inch.toString().replace(/ /gi, '') == '' ||
          (!this.height.inch && this.height.inch != 0) ||
          !this.weight
        ) {
          this.$emit('alert', 'Please fill out all the fields.');
          return;
        } else if (this.height.feet < 3) {
          this.$emit('alert', 'Feet should not be less than 3');
          return;
        } else if (this.height.feet > 8) {
          this.$emit('alert', 'Feet should not be greater than 8');
          return;
        } else if (this.height.inch > 11) {
          this.$emit('alert', 'Inch should not be greater than 11');
          return;
        } else if (this.height.inch < 0) {
          this.$emit('alert', 'Inch should not be less than 0');
          return;
        } else if (this.weight < 50) {
          this.$emit('alert', 'Weight should not be less than 50');
          return;
        } else if (this.weight > 400) {
          this.$emit('alert', 'Weight should not be greater than 400');
          return;
        }
      }
      this.$emit('submitAnswer', { height: this.height, weight: this.weight });
    },
    // Formatter
    numberOnly(value) {
      let removedNums = value.replace(/\D/g, '');
      if (removedNums.startsWith('0')) {
        removedNums = '0';
      } 
      if (removedNums.length > 2) {
        removedNums = removedNums.slice(0, 2);
      }
      return removedNums;
    },
    weightFormatter(value) {
      let removedNums = value.replace(/\D/g, '');
      if (removedNums.startsWith('0')) {
        removedNums = '0';
      }
      if (removedNums.length > 4) {
        removedNums = removedNums.slice(0, 4);
      }
      return removedNums;
    },
  },
};
</script>

<style lang="scss" scoped>
.form-control[type="number"],
.form-control[type="text"],
.bmi-input {
  border: 2px solid #e0e0e0;
  border-radius: 0.5rem;

  &:focus {
    border-color: $info;
  }
}

::v-deep .bmi-input-v2 {
  border-bottom: 1px solid #C7C7C7 !important;
  background-color: transparent !important;
  border-radius: 0;
  padding-left: 0.5rem;

  @include media-breakpoint-down(md) {
    border: 1px solid #C7C7C7 !important;
    border-radius: 0.5rem;
    padding-left: 1rem;
  }
}
</style>
